export const GroupedTreeStyles = () => {
  return {
    "& .glossary__card-items": {
      margin: "20px",
      marginTop: "10px",
    },
    "& .glossary__description": {
      margin: "10px",
      textAlign: "justify",
    },
    "& .glossary__row-color:nth-of-type(odd)":{
      background: "#E1D7F0"
    },
    '& .root': {
      height: "100%",
      flexGrow: 1,
      maxWidth: "100%",
    },
    "& .labelRoot": {
      alignItems: "center",
      padding: "4px 0px",
    },
    "& .labelTitle": {
      fontWeight: "bold",
      flexGrow: 1,
      margin: "10px",
    },
    "& .labelText": {
      fontWeight: "inherit",
      flexGrow: 1,
      margin: 10,
    },
    "& .MuiCollapse-root-MuiTreeItem-groupTransition": {
      marginLeft: "7px",
      paddingLeft: "18px",
      borderLeft: "1px dashed rgba(0, 0, 0, 0.4)",
    },
  }
}